module.exports = __webpack_public_path__ + "assets/images/android_first_install-aaa21b823e7ee146980fba58544ecc1d.webm";